import { render, staticRenderFns } from "./ExerciseV2Mount.vue?vue&type=template&id=71b923ce"
import script from "./ExerciseV2Mount.vue?vue&type=script&lang=js"
export * from "./ExerciseV2Mount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports